import { Utils } from '../helpers/utils';
import { PoptionalSelection } from './poptional-selection';

export class Selfservice {
	id: string;

	company_id: number;

	code: string;
	additional_info: string;

	status: 'unused'|'scanned'|'onuse'|'closed'|'cancelled'|'expired';

	created_at: string;
	updated_at: string;

	// set by our front end app
	parsedAdditionalInfo: {
		orders_received: number[],
		bill: SsBill
	};

	// given by server
	valid: boolean;

	static setAdditionalData(ss: Selfservice) {
		if(ss.additional_info) {
			let parsed = JSON.parse(ss.additional_info)
			ss.parsedAdditionalInfo = parsed;
			ss.parsedAdditionalInfo.bill = JSON.parse(parsed.bill).bill;
		}
	}

	static getBill(ss: Selfservice): SsBill {
		Selfservice.setAdditionalData(ss);
		if(!ss.parsedAdditionalInfo || !ss.parsedAdditionalInfo.bill)
			return null;

		const bill = ss.parsedAdditionalInfo.bill;
		return bill;
	}
	static checkOrderReceived(ss: Selfservice, orderId: number): boolean {
		Selfservice.setAdditionalData(ss);

		return ss.parsedAdditionalInfo.orders_received.indexOf(orderId) > -1;
	}
  static getPendingItems(ss: Selfservice, localOrders: SsOrder[]): SsOrderItem[] {
  	let items: SsOrderItem[] = [];

    for(let order of localOrders) {
      if(!Selfservice.checkOrderReceived(ss, order.id)) {
        for(let item of order.items) {
          item.status = 'pending';
          items.push(item);
        }
      }
    }

    return items;
  }
}
export class SsOrder {
	id: number;
	items: SsOrderItem[];
	created_at: string;
	received_at: string;
	updated_at: string;
}
export class SsOrderItem {
	id: number;
	product_name: string;
	product_price: string;
	quantity: number;
	created_at: string;
	updated_at: string;

	product_local_id: number;
	notes_attributes: {text: string}[];
	poptional_selections: PoptionalSelection[];
	notes: string;
	// Sent by the backend for items already on the bill (Bill#ss_items):
	// display-ready strings, one per selected poptional/subpoptional
	// (e.g. ["Medium fries", "2 Small fries"]). Not present on locally-built
	// pending items, which instead carry `poptional_selections` above.
	optional_names: string[];
	// set by our front end app
	status: 'pending'|'received';
	timeSince: string;

	static setAdditionalData(items: SsOrderItem[]) {
		for(let item of items) {
			item.timeSince = Utils.timeSince(item.created_at, new Date());
		}
	}
}
export class SsBill {
	id: number;

	base_value: string;
	couvert_fee: string;
	service_fee: string;
	extra_fees: string;
	discount: string;
	total_value: string;

	status: 'open'|'closing'|'closed'|'partially_payed'|'cancelled';

	custom_service_fee_rate: number|null;

	items: SsOrderItem[];

	//timestamps
	created_at: string;
	updated_at: string;
}